const mutations = {
  SET_RETURNS_FILTERS(state, { payload, audience }) {
    const objectives = payload && payload.objectives || [];
    const assetTypes = payload && payload.assetTypes || [];

    state.returnsFiltersData = {
      objectives,
      assetTypes
    };
  }
};

const getters = {
  returnsFiltersData: state => state.returnsFiltersData
};

const state = {
  returnsFiltersData: {
    objectives: [],
    assetTypes: []
  }
};

export default {
  state,
  mutations,
  getters
};
